module.exports = __webpack_public_path__ + "img/发抖.ba2c8246.png";